import { render, staticRenderFns } from "./taskDetail.vue?vue&type=template&id=25b724a9&scoped=true&"
import script from "./taskDetail.vue?vue&type=script&lang=js&"
export * from "./taskDetail.vue?vue&type=script&lang=js&"
import style0 from "./taskDetail.vue?vue&type=style&index=0&id=25b724a9&prod&lang=css&"
import style1 from "./taskDetail.vue?vue&type=style&index=1&id=25b724a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b724a9",
  null
  
)

export default component.exports